// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DiamondFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DiamondFilledIcon" ref={forwardedRef} {...props}>
      <path d="m9.993 1.868 8.125 8.125-8.125 8.125-8.125-8.125z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const DiamondFilledIcon = /* @__PURE__ */ Object.assign(
  DiamondFilledIconComponent,
  { displayName: 'DiamondFilledIcon' },
);
